<template lang="pug">
  v-container(fluid class="pt-0")
    Title(:titleName="companyItem.name" class="pb-6")
    v-row(no-gutters class="mb-5")
      v-carousel(v-if="companyItem.photos")
        v-carousel-item(v-for="(image, i) in companyItem.photos" :key="i")
          v-img(:src="image")
    v-row(no-gutters class="mb-3")
      p(class="company-page__description") {{ companyItem.description }}
    Title(:title-name="complexesTitle", class="mb-4")
    v-row
      v-col(cols="4", v-for="item in companyItem.complexes", :key="item.complexId")
        ComplexCard(:complex="item" @view-complex="viewComplexPage")
</template>
<script>
import Title from '../../components/Adverts/AddNew/Title'
import ComplexCard from '../../components/Complex/ComplexCard'
export default {
  name: 'CompanyPage',
  components: {
    ComplexCard,
    Title,
    Header: () => import('../../components/Header')
  },
  data: () => ({
    complexesTitle: 'Комплексы'
  }),
  watch: {
    companyItem(value) {
      console.log('value: ', value.length)
      value && value.complexes.length === 0
        ? (this.complexesTitle = 'У этой компании нет комплексов')
        : (this.complexesTitle = 'Комплексы')
    }
  },
  computed: {
    companyItem() {
      return this.$store.state.company.companyItem
    }
  },
  created() {
    this.$store.dispatch(
      'GET_COMPANY_ITEM_WITH_COMPLEXES',
      this.$route.params.id
    )
  },
  methods: {
    viewComplexPage(id) {
      this.$store.dispatch('SET_VIEWED_COMPLEX', id)
      this.$router.push({ path: `/complex/${id}` })
    }
  }
}
</script>
<style lang="scss" scoped>
.company-page {
  &__description {
    color: #8e8e93;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: -0.49 px;
  }
}
</style>
